export default {
    "available_in_your_tariff": "Sizin tarifinizdə mövcuddur",
    "market": "Bazar",
    "market_of_apps": "Tətbiq bazarı",
    "most_popular_apps": "Ən populyar tətbiqlər",
    "new_items": "Yeni əşyalar",
    "recommended_apps": "Tövsiyə olunan tətbiqlər",
    "setup": "Quraşdırma",
    "submit_an_application": "Ərizə təqdim edin",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Ərizəniz təqdim edildi, menecerimiz tezliklə sizinlə əlaqə saxlayacaq",
}
